import { render, staticRenderFns } from "./PageSettingsContext.vue?vue&type=template&id=57c9ec2e&scoped=true"
import script from "./PageSettingsContext.vue?vue&type=script&lang=js"
export * from "./PageSettingsContext.vue?vue&type=script&lang=js"
import style0 from "./PageSettingsContext.vue?vue&type=style&index=0&id=57c9ec2e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c9ec2e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57c9ec2e')) {
      api.createRecord('57c9ec2e', component.options)
    } else {
      api.reload('57c9ec2e', component.options)
    }
    module.hot.accept("./PageSettingsContext.vue?vue&type=template&id=57c9ec2e&scoped=true", function () {
      api.rerender('57c9ec2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings/page/PageSettingsContext.vue"
export default component.exports